import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=95f94068&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"
import style0 from "./Profile.vue?vue&type=style&index=0&id=95f94068&prod&lang=css"
import style1 from "./Profile.vue?vue&type=style&index=1&id=95f94068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f94068",
  null
  
)

export default component.exports